import { Component, EventEmitter, Input, Output } from '@angular/core';

import { trackByProp } from '@recruitee/common';
import { I18nService } from '@recruitee/i18n';
import { ThemeName } from '@recruitee/theme';

import { ThemeCardComponent, ThemeCardData } from './theme-card/theme-card.component';

@Component({
  selector: 'rt-theme-picker',
  templateUrl: './theme-picker.component.html',
  styleUrls: ['./theme-picker.component.less'],
  imports: [ThemeCardComponent],
})
export class ThemePickerComponent {
  @Input() public cardWidth: number | undefined;
  @Input() public cardHeight: number | undefined;
  @Input() public activeThemeName: ThemeName;
  @Input() public themeCardBackgroundSize: 'auto' | 'contain';
  @Output() public themeChange: EventEmitter<ThemeName> = new EventEmitter();

  public themeCards: ThemeCardData[] = [
    {
      title: this.i18n.translate('rtu.theme_picker.light'),
      subtitle: this.i18n.translate('rtu.theme_picker.default_subtitle'),
      theme: 'light',
    },
    {
      title: this.i18n.translate('rtu.theme_picker.dark'),
      theme: 'dark',
    },
    {
      title: this.i18n.translate('rtu.theme_picker.system_preferences_title'),
      theme: 'auto',
      iconHelpTooltip: this.i18n.translate('rtu.theme_picker.system_preferences_help'),
    },
  ];

  public trackByTheme = trackByProp<ThemeCardData>({ prop: 'theme' });

  constructor(private i18n: I18nService) {}
}
